export default "__VITE_ASSET__b0d11b4a__"